import { axiosInstance } from '../../App';
import { toast } from 'sonner';

export const downloadReportPdf = async (report) => {
  try {
    const res = await axiosInstance.get(`/schade-rapporten/${report.id}/pdf`, { responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = url; a.download = `Schaderapport_${report.number}.pdf`; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  } catch (e) {
    toast.error('PDF maken mislukt');
  }
};
